import { isArray } from './array';
import { isObject } from './object';

export function isRecord(
  value: unknown
): value is Record<string | number | symbol, unknown> {
  return isObject(value) && !isArray(value);
}

export function assertisRecord(
  value: unknown
): asserts value is Record<string | number | symbol, unknown> {
  if (!isRecord(value)) {
    throw TypeError(
      `Value is not of type Record<string | number | symbol, unknown>`
    );
  }
}

export function getRecordKeys<
  T extends Record<string | number | symbol, unknown>
>(record: T): ReadonlyArray<keyof T> {
  return Object.keys(record);
}
